<a *ngIf="workspacePermissions['intercompany-adjustment'] && workspacePermissions['wallet-adjustment']" class="btn btn-outline-primary m-2" [routerLink]="['/lo', company_uuid, 'intercompany-adjustment']">Inter-company Adjustment (A Out / B In)</a>

<div class="row">
    <div class="col-12 col-md-5 col-lg-4" >
        <ul class="nav nav-tabs">
            <li class="nav-item col">
                <a class="nav-link" [ngClass]="{'active': type === 'invalid-entry'}" (click)="switch('invalid-entry')">Invalid Entry</a>
            </li>
            <li class="nav-item col">
                <a class="nav-link" [ngClass]="{'active': type === 'without-daily-sales'}" (click)="switch('without-daily-sales')">Normal Adjustment</a>
            </li>
            <li class="nav-item col">
                <a class="nav-link" [ngClass]="{'active': type === 'bank'}" (click)="switch('bank')">Boss In/Out</a>
            </li>
        </ul>
        <ng-container *ngIf="type == 'invalid-entry'">
            <div class="p-3 border border-grey border-top-0">
                <div class="mb-3">
                    <label for="name" class="form-label fs-5 fw-bolder">Search Player</label>
                    <div class="input-group mb-3">
                        <input type="text" class="form-control form-contrl-lg" placeholder="Enter Player Code / Mobile / Name" #search="ngModel" (input)="searchPlayerChange()" [(ngModel)]="player_search"/>
                    </div>
                </div>
                <div *ngIf="is_searching_player">
                    <p>Searching Player</p>
                </div>
                <div *ngIf="!is_searching_player && players.length > 0 && !data.player_uuid" class="table-responsive" style="position: relative; z-index: 1;">
                    <table class="table table-sm table-striped table-warning">
                        <thead>
                            <th>Code</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th class="text-nowrap"></th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let player of players">
                                <td>{{player.code}}</td>
                                <td>{{player.name}}</td>
                                <td>{{player.mobile}}</td>
                                <td class="text-nowrap"><button class="btn btn-sm btn-outline-dark" (click)="selectPlayer(player.uuid)">Select</button></td>
                            </tr>
                        </tbody> 
                    </table>
                </div>
            </div>
            <div class="card rounded-0 border-top-0" *ngIf="data.player_uuid">
                <div class="card-header">
                    <div class="d-flex flex-row justify-content-between align-items-center">
                        <div class="d-flex flex-column">
                            <div class="card-title mb-0">Player Detail</div>
                            <h5 class="mb-0">{{player.name}} {{player.code}}</h5>
                        </div>
                        <button class="btn btn-sm btn-outline-dark" (click)="playerLog()">Logs</button>
                    </div>
                </div>
                <div class="card-body">
                    
                    <form #f="ngForm" (ngSubmit)="f.valid && (((data.bank_id != false && (data.bank_debit || data.bank_credit)) && (data.game_id != false && (data.game_debit || data.game_credit))) || ((data.bank_id == false && (data.game_id != false && (data.game_debit || data.game_credit))) || ((data.bank_id != false && (data.bank_debit || data.bank_credit)) && (data.game_id == false)))) && submit()" novalidate>
                        <h3 class="fs-4 fw-bold border-bottom border-grey pb-2">Adjustment</h3>
                        <div class="mb-3">
                            <label for="bank" class="form-label">Bank *</label>
                            <select class="form-control" name="bank" #bank="ngModel" [(ngModel)]="data.bank_id" required>
                                <option [value]="false">No Adjustment</option>
                                <option [value]="g.id" *ngFor="let g of banks;">{{g.title}} ({{g.balance}})</option>
                            </select>
                            <div *ngIf="f.submitted && bank.invalid" class="invalid-feedback">
                                <div *ngIf="bank.errors.required">Bank is required</div>
                            </div>
                        </div>
                        <ng-container *ngIf="data.bank_id != false">
                            <div class="mb-3">
                                <label for="bank_debit" class="form-label">Debit (&#43; In)</label>
                                <input type="number" class="form-control" id="bank_debit" name="bank_debit" #bank_debit="ngModel" [(ngModel)]="data.bank_debit" (input)="calculateProfit()">
                                <div *ngIf="f.submitted && ((!data.bank_debit && !data.bank_credit) || (data.bank_debit && data.bank_credit))" class="invalid-feedback">
                                    <div>You have to either debit or credit game. Can't be both value</div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="bank_credit" class="form-label">Credit (&#8722; Out)</label>
                                <input type="number" class="form-control" id="bank_credit" name="bank_credit" #bank_credit="ngModel" [(ngModel)]="data.bank_credit" (input)="calculateProfit()">
                                <div *ngIf="f.submitted && ((!data.bank_debit && !data.bank_credit) || (data.bank_debit && data.bank_credit))" class="invalid-feedback">
                                    <div>You have to either debit or credit game. Can't be both value</div>
                                </div>
                            </div>
                        </ng-container>
                        <hr/>
                        <div class="mb-3">
                            <label for="game" class="form-label">Game *</label>
                            <select class="form-control" name="game" #game="ngModel" [(ngModel)]="data.game_id" required>
                                <option [value]="false">No Adjustment</option>
                                <option [value]="g.id" *ngFor="let g of games;">{{g.title}} ({{g.balance}})</option>
                            </select>
                            <div *ngIf="f.submitted && game.invalid" class="invalid-feedback">
                                <div *ngIf="game.errors.required">Game is required</div>
                            </div>
                        </div>
                        <ng-container *ngIf="data.game_id != false">
                            <div class="mb-3">
                                <label for="game_debit" class="form-label">Debit (&#43; In)</label>
                                <input type="number" class="form-control" id="game_debit" name="game_debit" #game_debit="ngModel" [(ngModel)]="data.game_debit">
                                <div *ngIf="f.submitted && ((!data.game_debit && !data.game_credit) || (data.game_debit && data.game_credit))" class="invalid-feedback">
                                    <div>You have to either debit or credit game. Can't be both value</div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="game_credit" class="form-label">Credit (&#8722; Out)</label>
                                <input type="number" class="form-control" id="game_credit" name="game_credit" #game_credit="ngModel" [(ngModel)]="data.game_credit">
                                <div *ngIf="f.submitted && ((!data.game_debit && !data.game_credit) || (data.game_debit && data.game_credit))" class="invalid-feedback">
                                    <div>You have to either debit or credit game. Can't be both value</div>
                                </div>
                            </div>
                        </ng-container>
                        <hr/>
                        <div class="mb-3" *ngIf="data.game_id != false || data.bank_id != false">
                            <h3>Current Profit: {{player.profit}}</h3>
                            <label for="profit" class="form-label">Profit +/-</label>
                            <input type="number" class="form-control" id="profit" name="profit" #profit="ngModel" [(ngModel)]="data.profit" [readonly]="true">
                            <p class="small">New Profit: {{player.profit + (data.profit ?? 0)}}</p>
                        </div>
                        <hr *ngIf="data.game_id != false || data.bank_id != false"/>
                        <div class="mb-3" *ngIf="data.game_id != false || data.bank_id != false">
                            <label for="remark" class="form-label">Remark</label>
                            <textarea class="form-control" name="remark" #remark="ngModel" [(ngModel)]="data.remark"></textarea>
                        </div>
                        <button type="submit" class="btn btn-primary" *ngIf="data.game_id != false || data.bank_id != false" [disabled]="is_loading">Adjustment</button>
                    </form>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="type == 'bank'">
            <div class="card rounded-0 border-top-0" >
                <div class="card-body">
                    <form #f="ngForm" (ngSubmit)="f.valid && (data.bank_debit || data.bank_credit) && (!(data.bank_debit && data.bank_credit)) && submit()" novalidate>
                        <h3 class="fs-4 fw-bold border-bottom border-grey pb-2">Adjustment <small style="font-size:12px">(Boss in/out)</small></h3>
                        <div class="mb-3">
                            <label for="bank" class="form-label">Bank *</label>
                            <select class="form-control" name="bank" #bank="ngModel" [(ngModel)]="data.bank_id" required>
                                <option [value]="g.id" *ngFor="let g of banks;">{{g.title}} ({{g.balance}})</option>
                            </select>
                            <div *ngIf="f.submitted && bank.invalid" class="invalid-feedback">
                                <div *ngIf="bank.errors.required">Game is required</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="bank_debit" class="form-label">Debit (&#43; In)</label>
                            <input type="number" class="form-control" id="bank_debit" name="bank_debit" #bank_debit="ngModel" [(ngModel)]="data.bank_debit">
                            <div *ngIf="f.submitted && ((!data.bank_debit && !data.bank_credit) || (data.bank_debit && data.bank_credit))" class="invalid-feedback">
                                <div>You have to either debit or credit game. Can't be both value</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="bank_credit" class="form-label">Credit (&#8722; Out)</label>
                            <input type="number" class="form-control" id="bank_credit" name="bank_credit" #bank_credit="ngModel" [(ngModel)]="data.bank_credit">
                            <div *ngIf="f.submitted && ((!data.bank_debit && !data.bank_credit) || (data.bank_debit && data.bank_credit))" class="invalid-feedback">
                                <div>You have to either debit or credit game. Can't be both value</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="remark" class="form-label">Remark</label>
                            <textarea class="form-control" name="remark" #remark="ngModel" [(ngModel)]="data.remark"></textarea>
                        </div>
                        <button type="submit" class="btn btn-primary" [disabled]="is_loading">Adjustment</button>
                    </form>
                </div>
            </div>
        </ng-container>
        
        <ng-container *ngIf="type == 'without-daily-sales'">
            <div class="card rounded-0 border-top-0" >
                <div class="card-body">
                    <form #f="ngForm" (ngSubmit)="f.valid && (((data.bank_id != false && (data.bank_debit || data.bank_credit)) && (data.game_id != false && (data.game_debit || data.game_credit))) || ((data.bank_id == false && (data.game_id != false && (data.game_debit || data.game_credit))) || ((data.bank_id != false && (data.bank_debit || data.bank_credit)) && (data.game_id == false)))) && submit()" novalidate>
                        <h3 class="fs-4 fw-bold border-bottom border-grey pb-2">Adjustment <small style="font-size:12px">(No Added into Daily Sales)</small></h3>
                        <div class="mb-3">
                            <label for="bank" class="form-label">Bank *</label>
                            <select class="form-control" name="bank" #bank="ngModel" [(ngModel)]="data.bank_id" required>
                                <option [value]="false">No Adjustment</option>
                                <option [value]="g.id" *ngFor="let g of banks;">{{g.title}} ({{g.balance}})</option>
                            </select>
                            <div *ngIf="f.submitted && bank.invalid" class="invalid-feedback">
                                <div *ngIf="bank.errors.required">Bank is required</div>
                            </div>
                        </div>
                        <ng-container *ngIf="data.bank_id != false">
                            <div class="mb-3">
                                <label for="bank_debit" class="form-label">Debit (&#43; In)</label>
                                <input type="number" class="form-control" id="bank_debit" name="bank_debit" #bank_debit="ngModel" [(ngModel)]="data.bank_debit">
                                <div *ngIf="f.submitted && ((!data.bank_debit && !data.bank_credit) || (data.bank_debit && data.bank_credit))" class="invalid-feedback">
                                    <div>You have to either debit or credit game. Can't be both value</div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="bank_credit" class="form-label">Credit (&#8722; Out)</label>
                                <input type="number" class="form-control" id="bank_credit" name="bank_credit" #bank_credit="ngModel" [(ngModel)]="data.bank_credit">
                                <div *ngIf="f.submitted && ((!data.bank_debit && !data.bank_credit) || (data.bank_debit && data.bank_credit))" class="invalid-feedback">
                                    <div>You have to either debit or credit game. Can't be both value</div>
                                </div>
                            </div>
                        </ng-container>
                        <hr/>
                        <div class="mb-3">
                            <label for="game" class="form-label">Game *</label>
                            <select class="form-control" name="game" #game="ngModel" [(ngModel)]="data.game_id" required>
                                <option [value]="false">No Adjustment</option>
                                <option [value]="g.id" *ngFor="let g of games;">{{g.title}} ({{g.balance}})</option>
                            </select>
                            <div *ngIf="f.submitted && game.invalid" class="invalid-feedback">
                                <div *ngIf="game.errors.required">Game is required</div>
                            </div>
                        </div>
                        <ng-container *ngIf="data.game_id != false">
                            <div class="mb-3">
                                <label for="game_debit" class="form-label">Debit (&#43; In)</label>
                                <input type="number" class="form-control" id="game_debit" name="game_debit" #game_debit="ngModel" [(ngModel)]="data.game_debit">
                                <div *ngIf="f.submitted && ((!data.game_debit && !data.game_credit) || (data.game_debit && data.game_credit))" class="invalid-feedback">
                                    <div>You have to either debit or credit game. Can't be both value</div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="game_credit" class="form-label">Credit (&#8722; Out)</label>
                                <input type="number" class="form-control" id="game_credit" name="game_credit" #game_credit="ngModel" [(ngModel)]="data.game_credit">
                                <div *ngIf="f.submitted && ((!data.game_debit && !data.game_credit) || (data.game_debit && data.game_credit))" class="invalid-feedback">
                                    <div>You have to either debit or credit game. Can't be both value</div>
                                </div>
                            </div>
                        </ng-container>
                        <hr *ngIf="data.game_id != false || data.bank_id != false"/>
                        <div class="mb-3" *ngIf="data.game_id != false || data.bank_id != false">
                            <label for="remark" class="form-label">Remark</label>
                            <textarea class="form-control" name="remark" #remark="ngModel" [(ngModel)]="data.remark"></textarea>
                        </div>
                        <button type="submit" class="btn btn-primary" *ngIf="data.game_id != false || data.bank_id != false" [disabled]="is_loading">Adjustment</button>
                    </form>
                </div>
            </div>
        </ng-container>
    </div>  
    <div class="col-12 col-md-7 col-lg-8 border-start">
        <div class="row g-2 align-items-end p-2 bg-light border border-bottom-0">
            <div class="col-12 col-sm-4">
                <label class="form-label small mb-1" for="adjustment-date-from">Date From</label>
                <input id="adjustment-date-from" type="date" class="form-control form-control-sm" [(ngModel)]="history_filter.date_from" />
            </div>
            <div class="col-12 col-sm-4">
                <label class="form-label small mb-1" for="adjustment-date-to">Date To</label>
                <input id="adjustment-date-to" type="date" class="form-control form-control-sm" [(ngModel)]="history_filter.date_to" />
            </div>
            <div class="col-12 col-sm-4 d-flex gap-2">
                <button type="button" class="btn btn-sm btn-primary flex-fill" (click)="searchHistory()">Search</button>
                <button type="button" class="btn btn-sm btn-outline-secondary flex-fill" (click)="clearHistoryDates()">All Dates</button>
            </div>
        </div>
        <ul class="nav nav-tabs">
            <li class="nav-item col">
                <a class="nav-link" [ngClass]="{'active': table_type === 'bank'}" (click)="initTable('bank')">Bank Adjustment History</a>
            </li>
            <li class="nav-item col">
                <a class="nav-link" [ngClass]="{'active': table_type === 'game'}" (click)="initTable('game')">Game Adjustment History</a>
            </li>
        </ul>
        <app-table #table></app-table>
    </div>

</div>
